export default __webpack_public_path__ + "static/media/servizi-onlife.eb40659d.png";